import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, errMsg } from "../../lib/api";
import { Loading, ErrorBox } from "../../components/common";
import Certificate from "../../components/Certificate";

export default function PublicDocument() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get(`/public/documents/${token}`).then((r) => setD(r.data)).catch((e) => setErr(errMsg(e))); }, [token]);
  if (err) return <div className="max-w-lg mx-auto p-8" data-testid="public-document-error"><ErrorBox text={err} /></div>;
  if (!d) return <Loading />;
  return <Certificate branding={d.branding} doc={{ ...d, name: d.requester_name }} />;
}
